import { HelpOutline } from '@mui/icons-material';
import { Box, Stack, Tooltip, TooltipProps, useTheme } from '@mui/material';
import tokens from '@verifime/design-tokens';

export default function GroupWithTooltip({
  title,
  children,
  tooltipTitle,
  tooltipPlacement = 'right',
  tooltipArrow = true,
}: Readonly<{
  title: React.ReactNode;
  children: React.ReactNode;
  tooltipTitle?: React.ReactNode;
  tooltipPlacement?: TooltipProps['placement'];
  tooltipArrow?: boolean;
}>) {
  const theme = useTheme();
  return (
    <Box
      component="fieldset"
      sx={{
        border: `${tokens.spacing4xs} solid ${theme.palette.divider}`,
        borderRadius: tokens.borderRadiusSm,
        p: tokens.spacingBase,
      }}
    >
      <Stack
        component="legend"
        direction="row"
        sx={{
          alignItems: 'center',
          gap: tokens.spacingXs,
          px: tokens.spacingXs,
        }}
      >
        {title}
        {tooltipTitle && (
          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: 'background.paper',
                  color: 'text.primary',
                  '& .MuiTooltip-arrow': {
                    color: 'background.paper',
                  },
                  boxShadow: 1,
                },
              },
            }}
            title={tooltipTitle}
            placement={tooltipPlacement}
            arrow={tooltipArrow}
          >
            <HelpOutline
              sx={{ fontSize: tokens.fontSizeBase, color: 'text.secondary', cursor: 'help' }}
            />
          </Tooltip>
        )}
      </Stack>

      <Stack direction={['column', 'column', 'row']} gap={tokens.spacingBase}>
        {children}
      </Stack>
    </Box>
  );
}
